/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Newsletter_TitleInputs */

const en_why_listening_newsletter_title = /** @type {(inputs: Why_Listening_Newsletter_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forward a newsletter, hear it later`)
};

const es_why_listening_newsletter_title = /** @type {(inputs: Why_Listening_Newsletter_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reenvía una newsletter y escúchala después`)
};

/**
* | output |
* | --- |
* | "Forward a newsletter, hear it later" |
*
* @param {Why_Listening_Newsletter_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_newsletter_title = /** @type {((inputs?: Why_Listening_Newsletter_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Newsletter_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_newsletter_title(inputs)
	return en_why_listening_newsletter_title(inputs)
});